import { render, staticRenderFns } from "./ModalDialog.vue?vue&type=template&id=588431d2&scoped=true&"
import script from "./ModalDialog.vue?vue&type=script&lang=ts&"
export * from "./ModalDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588431d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('588431d2')) {
      api.createRecord('588431d2', component.options)
    } else {
      api.reload('588431d2', component.options)
    }
    module.hot.accept("./ModalDialog.vue?vue&type=template&id=588431d2&scoped=true&", function () {
      api.rerender('588431d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/common/components/ob1/ModalDialog.vue"
export default component.exports